export function reduce(arr, callbackFn, initialValue) {
    var accumulator = initialValue;
    for (var i = 0; i < arr.length; i += 1) {
        if (accumulator !== undefined) {
            accumulator = callbackFn.call(undefined, accumulator, arr[i], i, arr);
        }
        else {
            accumulator = arr[i];
        }
    }
    return accumulator;
}
